export const loyaltyProgramNames = {
  ihg: 'IHG Rewards Club',
  radisson: 'Radisson Rewards',
  choice: 'Choice Privileges',
  hyatt: 'World of Hyatt',
  wyndham: 'Wyndham Rewards',
  marriott: 'Marriott Bonvoy',
  bestwestern: 'Best Western Rewards',
  hilton: 'Hilton Honors',
  sonesta: 'Sonesta Travel Pass',
  // destiworld
  destiworld: 'Destiworld Loyalty'
}

export const loyaltyProgramLevelsList = {
  ihg: [
    { level: 'CLUB', program: null },
    { level: 'GOLD', program: null },
    { level: 'PLATINUM', program: null },
    { level: 'SPIRE', program: null },
    { level: 'DIAMOND', program: null },
    { level: 'SILVER', program: null }
  ],
  radisson: [
    { level: 'CLUB', program: null },
    { level: 'SILVER', program: null },
    { level: 'PLATINUM', program: null },
    { level: 'GOLD', program: null }
  ],
  choice: [
    { level: 'Elite Gold', program: null },
    { level: 'Elite Platinum', program: null },
    { level: 'Elite Diamond', program: null }
  ],
  hyatt: [
    { level: 'MEMB', program: null },
    { level: 'DISV', program: null },
    { level: 'EXPL', program: null },
    { level: 'GLOB', program: null },
    { level: 'LGLO', program: null }
  ],
  wyndham: [
    { level: 'BLUE', program: null },
    { level: 'GOLD', program: null },
    { level: 'PLATINUM', program: null },
    { level: 'DIAMOND', program: null },
    { level: 'TITATIUM', program: null }
  ],
  marriott: [
    { level: 'Member', program: null },
    { level: 'Silver Elite', program: null },
    { level: 'Gold Elite', program: null },
    { level: 'Platinum Elite', program: null },
    { level: 'Titanium Elite', program: null },
    { level: 'Ambassador Elite', program: null }
  ],
  bestwestern: [
    { level: 'BASE', program: null },
    { level: 'BLUE', program: null },
    { level: 'GOLD', program: null },
    { level: 'Platinum', program: null },
    { level: 'DIAMOND', program: null },
    { level: 'DIAMOND SELECT', program: null }
  ],
  hilton: [
    { level: 'Member', program: null },
    { level: 'Silver', program: null },
    { level: 'Gold', program: null },
    { level: 'Diamond', program: null }
  ],
  sonesta: [
    { level: 'SILVER', program: null },
    { level: 'BRONZE', program: null },
    { level: 'GOLD', program: null },
    { level: 'PLATINUM', program: null },
    { level: 'TRAVELPASS', program: null }
  ]
}

export const loyaltyProgramLevelNames = {
  ihg: {
    CLUB: 'Club',
    GOLD: 'Gold',
    PLATINUM: 'Platinum',
    SPIRE: 'Spire',
    DIAMOND: 'Diamond',
    SILVER: 'Silver'
  },
  radisson: {
    CLUB: 'Club',
    SILVER: 'Silver',
    PLATINUM: 'Platinum',
    GOLD: 'Gold'
  },
  choice: {
    'Elite Gold': 'Gold',
    'Elite Platinum': 'Platinum',
    'Elite Diamond': 'Diamond'
  },
  hyatt: {
    MEMB: 'Member',
    DISV: 'Discoverist',
    EXPL: 'Explorist',
    GLOB: 'Globalist',
    LGLO: 'Lifetime Globalist'
  },
  wyndham: {
    BLUE: 'Blue',
    GOLD: 'Gold',
    PLATINUM: 'Platinum',
    DIAMOND: 'Diamond',
    TITATIUM: 'Titanium'
  },
  marriott: {
    Member: 'Member',
    'Silver Elite': 'Silver Elite',
    'Gold Elite': 'Gold Elite',
    'Platinum Elite': 'Platinum Elite',
    'Titanium Elite': 'Titanium Elite',
    'Ambassador Elite': 'Ambassador Elite'
  },
  bestwestern: {
    BASE: 'Base',
    BLUE: 'Blue',
    GOLD: 'Gold',
    Platinum: 'Platinum',
    DIAMOND: 'Diamond',
    'DIAMOND SELECT': 'Diamond Select'
  },
  hilton: {
    Member: 'Member',
    Silver: 'Silver',
    Gold: 'Gold',
    Diamond: 'Diamond'
  },
  sonesta: {
    TRAVELPASS: 'Member',
    SILVER: 'Silver',
    BRONZE: 'Bronze',
    GOLD: 'Gold',
    PLATINUM: 'Platinum'
  }
}

export const loyaltyProgramLevels = {
  ihg: {
    CLUB: 'CLUB',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
    SPIRE: 'SPIRE',
    DIAMOND: 'DIAMOND',
    SILVER: 'SILVER'
  },
  radisson: {
    CLUB: 'CLUB',
    SILVER: 'SILVER',
    PLATINUM: 'PLATINUM',
    GOLD: 'GOLD'
  },
  choice: {
    'Elite Gold': 'Elite Gold',
    'Elite Platinum': 'Elite Platinum',
    'Elite Diamond': 'Elite Diamond'
  },
  hyatt: {
    MEMB: 'MEMB',
    DISV: 'DISV',
    EXPL: 'EXPL',
    GLOB: 'GLOB',
    LGLO: 'LGLO'
  },
  wyndham: {
    BLUE: 'BLUE',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
    DIAMOND: 'DIAMOND',
    TITATIUM: 'TITATIUM'
  },
  marriott: {
    Member: 'Member',
    'Silver Elite': 'Silver Elite',
    'Gold Elite': 'Gold Elite',
    'Platinum Elite': 'Platinum Elite',
    'Titanium Elite': 'Titanium Elite',
    'Ambassador Elite': 'Ambassador Elite'
  },
  bestwestern: {
    BASE: 'BASE',
    BLUE: 'BLUE',
    GOLD: 'GOLD',
    SILVER: 'SILVER',
    Platinum: 'Platinum',
    DIAMOND: 'DIAMOND',
    'DIAMOND SELECT': 'DIAMOND SELECT'
  },
  hilton: {
    Member: 'Member',
    Silver: 'Silver',
    Gold: 'Gold',
    Diamond: 'Diamond'
  },
  sonesta: {
    TRAVELPASS: 'TRAVELPASS',
    SILVER: 'SILVER',
    BRONZE: 'BRONZE',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM'
  }
}

export const loyaltyProgramLevelsNew = {
  ihg: {
    CLUB: {
      name: 'Club',
      code: 'CLUB'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    },
    SPIRE: {
      name: 'Spire',
      code: 'SPIRE'
    },
    DIAMOND: {
      name: 'Diamond',
      code: 'DIAMOND'
    },
    SILVER: {
      name: 'Silver',
      code: 'SILVER'
    }
  },
  radisson: {
    CLUB: {
      name: 'Club',
      code: 'CLUB'
    },
    SILVER: {
      name: 'Silver',
      code: 'SILVER'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    }
  },
  choice: {
    'Elite Gold': {
      name: 'Gold',
      code: 'Elite Gold'
    },
    'Elite Platinum': {
      name: 'Platinum',
      code: 'Elite Platinum'
    },
    'Elite Diamond': {
      name: 'Diamond',
      code: 'Elite Diamond'
    }
  },
  hyatt: {
    MEMB: {
      name: 'Member',
      code: 'MEMB'
    },
    DISV: {
      name: 'Discoverist',
      code: 'DISV'
    },
    EXPL: {
      name: 'Explorist',
      code: 'EXPL'
    },
    GLOB: {
      name: 'Globalist',
      code: 'GLOB'
    },
    LGLO: {
      name: 'Lifetime Globalist',
      code: 'LGLO'
    }
  },
  wyndham: {
    BLUE: {
      name: 'Blue',
      code: 'BLUE'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    },
    DIAMOND: {
      name: 'Diamond',
      code: 'DIAMOND'
    },
    TITATIUM: {
      name: 'Titanium',
      code: 'TITATIUM'
    }
  },
  marriott: {
    Member: {
      name: 'Member',
      code: 'Member'
    },
    'Silver Elite': {
      name: 'Silver Elite',
      code: 'Silver Elite'
    },
    'Gold Elite': {
      name: 'Gold Elite',
      code: 'Gold Elite'
    },
    'Platinum Elite': {
      name: 'Platinum Elite',
      code: 'Platinum Elite'
    },
    'Titanium Elite': {
      name: 'Titanium Elite',
      code: 'Titanium Elite'
    },
    'Ambassador Elite': {
      name: 'Ambassador Elite',
      code: 'Ambassador Elite'
    }
  },
  bestwestern: {
    BASE: {
      name: 'Base',
      code: 'BASE'
    },
    BLUE: {
      name: 'Blue',
      code: 'BLUE'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    Platinum: {
      name: 'Platinum',
      code: 'Platinum'
    },
    DIAMOND: {
      name: 'Diamond',
      code: 'DIAMOND'
    },
    'DIAMOND SELECT': {
      name: 'Diamond Select',
      code: 'DIAMOND SELECT'
    }
  },
  hilton: {
    Member: {
      name: 'Member',
      code: 'Member'
    },
    Silver: {
      name: 'Silver',
      code: 'Silver'
    },
    Gold: {
      name: 'Gold',
      code: 'Gold'
    },
    Diamond: {
      name: 'Diamond',
      code: 'Diamond'
    }
  },
  sonesta: {
    TRAVELPASS: {
      name: 'Member',
      code: 'TRAVELPASS'
    },
    SILVER: {
      name: 'Silver',
      code: 'SILVER'
    },
    BRONZE: {
      name: 'Bronze',
      code: 'BRONZE'
    },
    GOLD: {
      name: 'Gold',
      code: 'GOLD'
    },
    PLATINUM: {
      name: 'Platinum',
      code: 'PLATINUM'
    }
  }
}

export const merchantsHaveDynamicLevels = ['Destiworld']
